import { render, staticRenderFns } from "./CatchByFish.vue?vue&type=template&id=483ed940&"
import script from "./CatchByFish.vue?vue&type=script&lang=js&"
export * from "./CatchByFish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports